import { IJxtCounterPicto } from './types';
import { ResourceStateDtoStatusEnum } from '@jooxter/api';
import { getThemeColorHex } from '@jooxter/tailwind-config';

const JxtCounterPicto = ({ radius = 10, occupantsCount, capacity, x, y, size, status }: IJxtCounterPicto) => {
  if (occupantsCount === undefined || !capacity) {
    return null;
  }

  const circumference = 2 * Math.PI * radius; // Donne la circonférence pour le remplir à 100% (cercle entièrement rouge)
  const filledRatio = circumference - (occupantsCount / capacity) * circumference; // Calcule la partie qui doit être remplie en rouge

  return (
    <g>
      {status === ResourceStateDtoStatusEnum.Closed || !status ? (
        <circle
          cx={x + size / 2}
          cy={y + size / 2}
          r={radius}
          fill="none"
          stroke={getThemeColorHex('neutral100')}
          strokeWidth={radius / 1.9}
        />
      ) : (
        <>
          <circle
            cx={x + size / 2}
            cy={y + size / 2}
            r={radius}
            fill="none"
            stroke={getThemeColorHex('green100')}
            strokeWidth={radius / 1.9}
          />

          <circle
            cx={x + size / 2}
            cy={y + size / 2}
            r={radius}
            fill="none"
            stroke={getThemeColorHex('red100')}
            strokeWidth={radius / 1.9}
            strokeDasharray={circumference}
            strokeDashoffset={filledRatio}
            strokeLinecap="butt"
            transform={`rotate(-90 ${x + size / 2} ${y + size / 2})`}
          />
        </>
      )}
    </g>
  );
};

export default JxtCounterPicto;
